import React, { FC } from 'react';
//import IntlTelInput from 'react-intl-tel-input';
import styled from 'styled-components';
import ErrorImg from '../assets/error-icon.svg';
interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

interface TelProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  info?: string;
}

export const UIInput: FC<Props> = props => {
  const { label, error } = props;

  return (
    <div>
      {label && <Label>{label}</Label>}
      <Content>
        <Input {...props} className={`ui-nucleus ${props.className ? props.className : ''}`} />
        {error && <ErrorIcon src={ErrorImg} />}
      </Content>
      <ErrorText visible={!!error}>{error}</ErrorText>
    </div>
  );
};

export const UIWhiteBoxInput: FC<Props> = props => {
  const { label, error, required } = props;

  return (
    <div>
      <Label>
        {label} {required ? <span style={{ color: '#FE3824' }}>*</span> : <></>}
      </Label>
      <Content>
        <WhiteBoxInput {...props} className={`ui-nucleus ${props.className ? props.className : ''}`} />
        {error && <WhiteBoxErrorIcon src={ErrorImg} />}
      </Content>
      <WhiteBoxErrorText visible={!!error}>{error}</WhiteBoxErrorText>
    </div>
  );
};

export const UIWhiteBoxTelInput: FC<TelProps> = props => {
  const { label, error, info, required } = props;
  return (
    <div>
      <Label>
        {label} {required ? <span style={{ color: '#FE3824' }}>*</span> : null}
      </Label>
      <Content>{error && <WhiteBoxErrorIcon src={ErrorImg} />}</Content>
      {<WhiteBoxHelpText visible={!!info}>{info} </WhiteBoxHelpText>}
      <WhiteBoxErrorText visible={!!error}>{error}</WhiteBoxErrorText>
    </div>
  );
};

const Input = styled.input<{ error?: string }>`
  width: 100%;
  padding: 16px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
  font-size: 16px;
  height: 50px;
  box-shadow: none;
  border-color: ${(props: { error?: string }) => (props.error ? '#FF4B30' : '#ccc')};
`;

const WhiteBoxInput = styled.input<{ error?: string }>`
  width: 95% !important;
  margin: 0px !important;
  padding: 4px 10px !important;
  border-radius: 5px !important;
  border: none;
  height: 2.5rem;
  background-color: #fff !important;
  font-size: 16px !important;
  box-shadow: none !important;
  border-color: ${(props: { error?: string }) => (props.error ? '#FF4B30' : '#ccc')};
`;

const Label = styled.p`
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 16px;
  color: #0a313f;
`;

const Content = styled.div`
  position: relative;
`;

const ErrorText = styled.div<{ visible?: boolean }>`
  color: #fe3824;
  font-size: 10px;
  margin-top: 5px;
  margin-bottom: 0px;
  height: 15px;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
`;

const WhiteBoxErrorText = styled.div<{ visible?: boolean }>`
  color: #fe3824;
  font-size: 10px;
  margin-top: 5px;
  margin-bottom: 0px;
  height: 15px;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
`;

const WhiteBoxHelpText = styled.div<{ visible?: boolean }>`
  font-size: 10px;
  margin-top: 5px;
  margin-bottom: 0px;
  height: 15px;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
`;

const ErrorIcon = styled.img`
  position: absolute;
  right: 10px;
  top: 40%;
`;

const WhiteBoxErrorIcon = styled.img`
  position: absolute;
  right: 10px;
  top: 20%;
`;
